'use client';

import { useTranslations } from 'next-intl';
import CustomLink from 'components/shared/CustomLink';
import { CardioAdaptibilityShopifyMap } from 'content/products/addons/cardioAdaptibility';
import { CurrencySymbol, useFormatPrice } from 'hooks/pricing/useFormattedPrice';
import { useWindowSize } from 'hooks/dom/useWindowSize';
import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { useCartStore, useShallow } from 'components/shared/Cart';
import { CustomImage } from '../custom-image';
import {
  Button,
  ImageContainer,
  InfoModalContainer,
  InfoModalDescription,
  InfoModalTitle,
  PricingModal,
} from './layout';
import { getAssetUrl } from 'lib/config/assetUrls';
import { FSAHSAComponent } from '../HsaFsaComponent';
import { Currency } from 'utils/Currency';

export const CardioAdaptabilityCartInfoModal = () => {
  const t = useTranslations('ring');
  const CartClient = useCartStore(
    useShallow((s) => ({ store: s.store, currency: s.currency })),
  );

  const { store, currency } = CartClient;
  const CurrencyCode = CurrencySymbol[currency ?? Currency.usd];

  const { width } = useWindowSize();
  const formatPriceWithComma = useFormatPrice();

  return (
    <InfoModalContainer>
      <InfoModalTitle>
        <h3>{t('ring.infoModals.cardio.title')}</h3>

        <p>
          <span>
            {t('ring.infoModals.cardio.subtitle.a')}
            <>
              {CurrencyCode}
              {formatPriceWithComma(
                CardioAdaptibilityShopifyMap[store as ShopifyStore].Year2
                  .price / 2,
              )}
            </>
            {t('ring.infoModals.cardio.subtitle.b')}
          </span>

          <span>
            <FSAHSAComponent />
          </span>
        </p>

        <ImageContainer className="cardio-container">
          <CustomImage
            src={`web_v2/cart-info-modals/cardio_adaptability${
              width > 1024 ? '_desktop' : ''
            }.png`}
            width={1388}
            height={1133}
            alt={t('ring.infoModals.cardio.imageAlt')}
            priority
          />
        </ImageContainer>
      </InfoModalTitle>
      <InfoModalDescription>
        <p>{t('ring.infoModals.powerplugs')}</p>
        <p>
          <strong>{t('ring.infoModals.cardio.descriptionStrong')}</strong>{' '}
          {t('ring.infoModals.cardio.description')}
        </p>
      </InfoModalDescription>
      <InfoModalDescription>
        <h3>{t('ring.infoModals.cardio.text.a.title')}</h3>
        <p>{t('ring.infoModals.cardio.text.a.p1')}</p>
        <p>{t('ring.infoModals.cardio.text.a.p2')}</p>
      </InfoModalDescription>
      <InfoModalDescription>
        <h3>{t('ring.infoModals.cardio.text.b.title')}</h3>
        <p>{t('ring.infoModals.cardio.text.b.p1')}</p>
      </InfoModalDescription>
      <ImageContainer className="screen">
        <CustomImage
          src="web_v2/cart-info-modals/cardio_complications.png"
          width={1388}
          height={875}
          alt={t('ring.infoModals.cardio.complicationsAlt')}
          priority
        />
      </ImageContainer>
      <CustomLink
        rel="noopener noreferrer"
        href={getAssetUrl('/web_v2/downloads/cardio-report.pdf')}
        target={'_blank'}
      >
        <Button>
          <span>{t('ring.infoModals.cardio.button')}</span>
        </Button>
      </CustomLink>
    </InfoModalContainer>
  );
};

export const CardioAdaptabilityPricingModal = () => (
  <PricingModal>
    <CardioAdaptabilityCartInfoModal />
  </PricingModal>
);
